module.exports = __webpack_public_path__ + "img/btn-jc-bg2.6db80cdd.png";